import React, { lazy } from 'react';
import { Routes, Route } from 'react-router-dom';

const ParentCompany = lazy(() => import('../../pages/ParentCompany/ParentCompanyPage'));

function PagesRoute() {
  return (
    <Routes>
      <Route path="/*" element={<ParentCompany />} />
    </Routes>
  );
}

export default PagesRoute;
